import { HStack, VStack } from "@chakra-ui/react";
import { motion } from "framer-motion";
import Button from "@/components/common/Button";
import { useNavigate } from "react-router-dom";
import { NAVIGATION_ROUTES } from "@/routes/constants";

const MotionDiv = motion.div;

const Unauthorized = () => {
  const text = "Stop! You are unauthorized to access this page";

  const getColor = (index: number) => {
    return index % 2 === 0 ? "#A71C29" : "#FEA01A";
  };
  const navigate = useNavigate();

  const motionTransition = {
    delay: 0.05,
    duration: 0.5,
    type: "spring",
    stiffness: 100,
    damping: 15,
  };

  return (
    <div
      style={{
        width: "100%",
        height: "50vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: "0 20px",
        boxSizing: "border-box",
      }}
    >
      <VStack gap={4} fontFamily={"primary"}>
        <HStack width={{ base: "100%", md: "80%" }} justifyContent="center">
          <motion.div
            style={{
              fontSize: "4vw",
              fontFamily: "Arial, sans-serif",
              lineHeight: "1.2",
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            {text.split("").map((char, index) =>
              char === " " ? (
                <div key={index} style={{ width: "2vw" }} />
              ) : (
                <MotionDiv
                  key={index}
                  style={{
                    color: getColor(index),
                    paddingLeft: "2px",
                    paddingRight: "2px",
                  }}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ ...motionTransition, delay: index * 0.05 }}
                >
                  {char}
                </MotionDiv>
              )
            )}
          </motion.div>
        </HStack>
        <Button onClick={() => navigate(NAVIGATION_ROUTES.HOME)}>
          Back to Dashboard
        </Button>
      </VStack>
    </div>
  );
};

export default Unauthorized;
